import React from 'react';
import * as ds from './dataService';
import { FormBaseLayout } from 'modules/components/layer10';

export type RemoveIncidentFormProps = {
  id: string;
  handleClose: () => void;
};

export const FC = (props: RemoveIncidentFormProps) => {
  const [
    fnRemoveIncidentForm,
    { loading }
  ] = ds.useRemoveIncident();

  const handleSubmit = async (id: string) => {

    await fnRemoveIncidentForm(id);
    props.handleClose();
  };

  return (
    <FormBaseLayout.FC
      handleCancel={() => props.handleClose()}
      handleSubmit={() => {
        handleSubmit(props.id);
      }}
      cancelButtonText='Cancel'
      successButtonText='Save'
      isLoading={loading}
    >
      <></>
      {/* ADD FIELDS */}
    </FormBaseLayout.FC>

  );
};
